// ダウンロードごとに非表示の iframe を使う。
// a 要素のクリックは現在のページ自体の遷移になるため、複数ファイルを続けて開始すると
// 後の遷移が先の遷移を打ち切り、片方しか保存されないことがある。
const CLEANUP_DELAY_MS = 60_000;

export const downloadViaIframe = (url: string) => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = url;
  document.body.appendChild(iframe);
  // 応答が来る前に消すとダウンロードが中断されるため、十分な猶予を置いて片付ける
  setTimeout(() => iframe.remove(), CLEANUP_DELAY_MS);
};
